import { motion } from "framer-motion";
import { AreaLayout } from "@/components/AreaLayout";

const CATEGORIAS = ["Calmar", "Escuchar", "Afrontar el miedo", "Sostener"];

const PRACTICAS = [
  { t: "Pausa consciente", min: "5 min", c: "Calmar" },
  { t: "Volver al cuerpo", min: "8 min", c: "Escuchar" },
  { t: "Antes de decidir", min: "10 min", c: "Afrontar el miedo" },
];

export default function Medita() {
  return (
    <AreaLayout>
      <p className="eyebrow mb-4">Medita</p>
      <h1 className="font-display text-4xl text-[#102B5B] sm:text-5xl" style={{ fontWeight: 600 }} data-testid="medita-title">
        Un espacio para bajar el ruido.
      </h1>

      <div className="mt-8 flex flex-wrap gap-2" data-testid="medita-categorias">
        {CATEGORIAS.map((c) => (
          <span key={c} className="rounded-full border border-[#C5D7F4] bg-[#F4F7FD] px-4 py-2 text-sm font-semibold text-[#1F4C98]">
            {c}
          </span>
        ))}
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-3">
        {PRACTICAS.map((p, i) => (
          <motion.div
            key={p.t}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: i * 0.08 }}
            className="soft-card overflow-hidden"
            data-testid={`medita-practica-${i}`}
          >
            {/* Portada dibujada en código: ondas de calma */}
            <div className="relative h-32 bg-[#E6EEFA]">
              <svg viewBox="0 0 400 128" className="h-full w-full" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0 80 Q100 50 200 80 T400 80" fill="none" stroke="#C5D7F4" strokeWidth="2" />
                <path d="M0 95 Q100 65 200 95 T400 95" fill="none" stroke="#275FBE" strokeWidth="2" opacity="0.5" />
                <path d="M0 65 Q100 35 200 65 T400 65" fill="none" stroke="#1F4C98" strokeWidth="1.5" opacity="0.35" />
              </svg>
            </div>
            <div className="p-6">
              <span className="text-sm font-semibold text-[#1F4C98]">{p.c}</span>
              <h2 className="mt-1 text-xl font-semibold text-[#171A20]">{p.t}</h2>
              <p className="mt-1 text-sm text-[#626B79]">{p.min}</p>
              <button
                type="button"
                disabled
                data-testid={`medita-cta-${i}`}
                className="mt-4 w-full cursor-not-allowed rounded-full border border-[#D6DAE0] bg-[#F4F7FD] py-2.5 text-base font-semibold text-[#626B79]"
              >
                Próximamente
              </button>
            </div>
          </motion.div>
        ))}
      </div>
      <p className="mt-6 text-sm text-[#626B79]">
        Las prácticas en audio llegarán en una próxima versión. Las categorías son una propuesta
        inicial.
      </p>
    </AreaLayout>
  );
}
